export default __webpack_public_path__ + "static/media/front.e1abae92.svg";